export default "__VITE_ASSET__oTwj8E5d__"